// "Notify me when restocked" (product pages + product cards everywhere).
//
// The bell on a sold-out size — or anywhere on that size's box, which
// shows "Notify me" on hover (snippets/product-variant-options.liquid) —
// opens the pop-up (sections/main-product.liquid) without selecting that
// size. The pop-up's email is checked the same way as the site's other
// email boxes (footer / homepage JOIN): empty -> "This field is required",
// invalid -> "Please enter a valid email", shown in the same alert box with
// a red outline. A valid email is sent through Shopify's contact form
// (product, size and product link included) in the background with no page
// reload, and the pop-up instantly shows its thank-you message
// (assets/inline-signup.js). Listeners are on the document, so they keep
// working after the size buttons are re-rendered on a variant change.
(function () {
  if (window.__p3RestockNotify) return;
  window.__p3RestockNotify = true;

  var lastFocus = null;

  function getModal() {
    return document.querySelector('[data-notify-modal]');
  }

  function parts(modal) {
    var form = modal.querySelector('form');
    return {
      form: form,
      productField: form && form.querySelector('[data-notify-product-field]'),
      urlField: form && form.querySelector('[data-notify-url-field]'),
      input: form && form.querySelector('.p3-notify-modal__input'),
      errorEl: form && form.querySelector('.p3-notify-modal__error'),
      fields: form && form.querySelector('[data-signup-fields]'),
      success: form && form.querySelector('[data-signup-success]'),
      optionField: form && form.querySelector('[data-notify-option-field]'),
      body: form && form.querySelector('[data-notify-body]'),
    };
  }

  function clearError(p) {
    p.input.classList.remove('is-invalid');
    p.errorEl.hidden = true;
  }

  function showError(p, message) {
    p.input.classList.add('is-invalid');
    p.errorEl.textContent = message;
    p.errorEl.hidden = false;
  }

  // trigger: a sold-out size's bell / box, the sold-out Add to cart button
  // (option + value of the selected size passed in), or a product card's
  // SOLD OUT button (data-notify-product / data-notify-url, no size).
  function open(trigger, optionOverride, valueOverride) {
    var modal = getModal();
    if (!modal) return;
    var p = parts(modal);
    if (!p.form || !p.input) return;

    var product = trigger.getAttribute('data-notify-product') || modal.getAttribute('data-default-product') || '';
    var url = trigger.getAttribute('data-notify-url') || modal.getAttribute('data-default-url') || '';
    var option = optionOverride || trigger.getAttribute('data-notify-option') || '';
    var value = valueOverride || trigger.getAttribute('data-notify-value') || '';
    if (p.productField) p.productField.value = product;
    if (p.urlField) p.urlField.value = url;
    p.optionField.value = value ? (option || 'Size') + ': ' + value : 'Any size';
    p.body.value = 'Notify me when restocked: ' + product + (value ? ' — ' + (option || 'Size') + ' ' + value : '');

    // fresh form every time (e.g. after signing up for another size)
    p.input.value = '';
    clearError(p);
    if (p.fields) p.fields.style.display = '';
    if (p.success) p.success.hidden = true;

    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('p3-notify-open');
    setTimeout(function () {
      try {
        p.input.focus({ preventScroll: true });
      } catch (e) {
        p.input.focus();
      }
    }, 0);
  }

  // While the pop-up is open for a sold-out size, that size shows as the
  // selected one (with its bell) and the actually selected size as
  // unselected (.p3-size-notifying / .p3-sizes-notifying, "Sold-out size
  // shown as selected" in assets/custom-styles.css). Only the look: the
  // product's real selection never changes, so on closing it's back.
  function markNotifying(label) {
    clearNotifying();
    if (!label) return;
    var fieldset = label.closest('fieldset');
    label.classList.add('p3-size-notifying');
    if (fieldset) fieldset.classList.add('p3-sizes-notifying');
  }

  function clearNotifying() {
    document.querySelectorAll('.p3-size-notifying').forEach(function (el) {
      el.classList.remove('p3-size-notifying');
    });
    document.querySelectorAll('.p3-sizes-notifying').forEach(function (el) {
      el.classList.remove('p3-sizes-notifying');
    });
  }

  function close() {
    var modal = getModal();
    if (!modal || modal.hidden) return;
    clearNotifying();
    modal.hidden = true;
    document.documentElement.classList.remove('p3-notify-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function attemptSubmit() {
    var modal = getModal();
    if (!modal) return;
    var p = parts(modal);
    if (!p.input.value.trim()) {
      showError(p, 'This field is required');
      p.input.focus();
      return;
    }
    if (!p.input.checkValidity()) {
      showError(p, 'Please enter a valid email');
      p.input.focus();
      return;
    }
    clearError(p);
    if (window.P3Signup) window.P3Signup.submitting(p.form);
    if (p.form.requestSubmit) {
      p.form.requestSubmit();
    } else {
      p.form.submit();
    }
  }

  // The selected size on a product page (for the sold-out Add to cart).
  function selectedSize(from) {
    var info = from.closest('.product__info-container') || document;
    var checked = info.querySelector('variant-selects fieldset input[type="radio"]:checked');
    if (!checked) return null;
    var fieldset = checked.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('legend');
    return { option: legend ? legend.textContent.trim().replace(/:$/, '') : 'Size', value: checked.value };
  }

  // Bell: open the pop-up, and don't let the click select the size.
  document.addEventListener(
    'click',
    function (event) {
      // a product card's SOLD OUT – NOTIFY ME WHEN RESTOCKED button (don't
      // follow the card's link)
      var cardButton = event.target.closest('.card__badge .badge--sold-out[data-notify-product]');
      if (cardButton) {
        event.preventDefault();
        event.stopPropagation();
        open(cardButton);
        return;
      }
      // the product page's sold-out Add to cart (a disabled button, so the
      // click lands on its wrapper — see "Sold out: notify me" in
      // assets/custom-styles.css)
      var buttons = event.target.closest('.product__info-container .product-form__buttons');
      var soldOutSubmit = buttons && buttons.querySelector('.product-form__submit[disabled]');
      if (soldOutSubmit && /notify/i.test(soldOutSubmit.textContent)) {
        event.preventDefault();
        event.stopPropagation();
        var size = selectedSize(buttons);
        open(soldOutSubmit, size && size.option, size && size.value);
        return;
      }
      var soldOutBox = event.target.closest('label.p3-size-soldout');
      var bell = event.target.closest('.p3-notify-bell') || (soldOutBox && soldOutBox.querySelector('.p3-notify-bell'));
      if (bell) {
        event.preventDefault();
        event.stopPropagation();
        open(bell);
        markNotifying(bell.closest('label.p3-size-soldout'));
        return;
      }
      if (event.target.closest('[data-notify-close]')) {
        event.preventDefault();
        close();
        return;
      }
      if (event.target.closest('.p3-notify-modal__button')) {
        event.preventDefault();
        attemptSubmit();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var cardKey = event.target.closest && event.target.closest('.card__badge .badge--sold-out[data-notify-product]');
      if (cardKey && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.stopPropagation();
        open(cardKey);
        return;
      }
      var bell = event.target.closest && event.target.closest('.p3-notify-bell');
      if (bell && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.stopPropagation();
        open(bell);
        markNotifying(bell.closest('label.p3-size-soldout'));
        return;
      }
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key === 'Enter' && event.target.matches && event.target.matches('.p3-notify-modal__input')) {
        event.preventDefault();
        attemptSubmit();
      }
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      if (!event.target.matches || !event.target.matches('.p3-notify-modal__input')) return;
      var modal = getModal();
      if (modal) clearError(parts(modal));
    },
    true
  );

  // Safety net: never send an empty / invalid email.
  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target.matches || !event.target.matches('.p3-notify-modal__form')) return;
      var input = event.target.querySelector('.p3-notify-modal__input');
      if (!input || !input.value.trim() || !input.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
